import { eventService } from '../_services'
import { router } from '../_helpers'
const initialState = {
  tags: [], events: [], event: null, loaded: false, enroll: null }
export const event = {
  namespaced: true,
  state: initialState,
  actions: {

    search ({ dispatch }, { q, start, end }) {
      router.push('/eventi/all?q=' + q + '&start=' + start + '&end=' + end)
    },
    enrollment ({ dispatch }, { enroll, vm }) {
      eventService.enrollment(enroll)
        .then(
          s => {
            if (s.error) {
              vm.errormessage = s.message
            } else {
              dispatch('message/enrollment', { enroll: s, success: s.success, message: s.errorMessage, userEnroll: enroll }, { root: true })
            }
          },
          error => {
            dispatch('message/enrollment', { enroll: null, success: false, message: error.message, userEnroll: enroll }, { root: true })
          }
        )
    },

    maxposti ({ dispatch }, enroll) {
      return eventService.maxposti(enroll)
    },

    confirmEnrollment ({ dispatch }, id) {
      eventService.confirmEnrollment(id)
        .then(
          s => {
            if (s.response && s.response.status === 404) {
              router.push('/404')
            }
            if (s.response && s.response.status >= 500) {
              dispatch('message/enrollmentConfirm', { enroll: null, success: false, message: s.response.data.ExceptionMessage }, { root: true })

              return
            }
            dispatch('message/enrollmentConfirm', { enroll: s, success: true, message: '' }, { root: true })
          },
          error => {
            dispatch('message/enrollmentConfirm', { enroll: null, success: false, message: error.response.data.ExceptionMessage }, { root: true })
          }
        )
    },

    removeenrollmentbycode ({ dispatch }, request) {
      eventService.removeEnrollmentByCode(request)
        .then(
          s => {
            if (s.response && s.response.status == 404) {
              dispatch('message/enrollmentCancellation', { enroll: null, success: false, message: 'Codice Prenotazione non riconosciuto' }, { root: true })
              return
            }
            dispatch('message/enrollmentCancellation', { enroll: s, success: true, message: 'Annullamento avvenuto con successo' }, { root: true })
          },
          error => {
            dispatch('message/enrollmentCancellation', { enroll: null, success: false, message: error.response.data.message }, { root: true })
            console.log(error.response)
          }
        )
    },
    removeEnrollment ({ dispatch }, id) {
      eventService.removeEnrollment(id)
        .then(
          s => {
            dispatch('message/enrollmentCancellation', { enroll: s, success: true, message: 'Annullamento avvenuto con successo' }, { root: true })
          },
          error => {
            dispatch('message/enrollmentCancellation', { enroll: null, success: false, message: error.response.data.message }, { root: true })
            console.log(error.response)
          }
        )
    },

    tags ({ dispatch, commit }) {
      eventService.tags().then(tags => {
        commit('tagsSuccess', tags)
      })
    },

    events ({ dispatch, commit }, { tag, start, end, q }) {
      commit('clearEventsSuccess', [])
      eventService.events(tag, start, end, q).then(events => {
        commit('eventsSuccess', events)
      })
    },

    clearEvents ({ dispatch, commit }) {
      commit('clearEventsSuccess', [])
    },

    event ({ dispatch, commit }, { slug }) {
      eventService.event(slug).then(event => {
        commit('eventSuccess', event)
      })
    }
  },
  mutations: {
    selectedWeekUpdate (state, value) {
      state.selectedWeek = value
    },
    selectedLevelUpdate (state, value) {
      state.selectedLevel = value
    },

    tagsSuccess (state, tags) {
      state.tags = tags
    },

    eventsSuccess (state, events) {
      state.events = events
      state.loaded = true
    },

    clearEventsSuccess (state, events) {
      state.events = events
      state.loaded = false
    },

    eventSuccess (state, event) {
      if (event.response && event.response.status == 404) {
        router.push('/404')
      }

      state.event = event
    }

  }

}
